import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import RoundedButton from 'components/Shared/RoundedButton';
import { useSelector } from 'react-redux';
import CopyableLink from '../../Shared/CopyableLink';

const useStyles = makeStyles((theme) => ({
  createButton: {
    textTransform: 'uppercase',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
    letterSpacing: 2,
    fontWeight: 'bold',
    fontSize: 13,
    maxHeight: 40,
  },
}));

const AssessmentUrl = ({
                         onCloseModal,
                         link,
                       }) => {
  const classes = useStyles();
  const { en: { btn } } = useSelector((state) => state.i18n);

  function openInNewTab() {
    if (link) {
      window.open(link,   '_blank').focus();
    }
  }

  return (
    <>
      <CopyableLink link={link} />
      <Box pt={3} display='flex' justifyContent='center'>
        <RoundedButton
          variant='contained'
          color='primary'
          size='small'
          onClick={openInNewTab}
          className={classes.createButton}
        >
          {btn.openAssessmentIntoNewTab}
        </RoundedButton>
      </Box>
      <Box pt={7} pb={2} display='flex' justifyContent='center'>
        <RoundedButton
          variant='outlined'
          color='primary'
          size='small'
          onClick={onCloseModal}
          className={classes.createButton}
        >
          {btn.close}
        </RoundedButton>
      </Box>
    </>
  );
};

AssessmentUrl.propTypes = {
  link: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default AssessmentUrl;
